import { Uuid } from "../../domain/model/uuid/uuid.type";
import { RemovalViewModel } from "./removal.viewmodel";

export class RemovalSaveInfoViewModel {

  constructor(
    readonly id: Uuid,
    readonly removal: RemovalViewModel) { }
}
